import { GenIcon } from '../helpers/IconBase.es.js';

const SliderFilled = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 13", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M3.44452 4.77771L1.88896 6.33327L3.44452 7.88882",
              stroke: "white",
              strokeWidth: "0.333333",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          }
        ]
      },
      {
        tag: "rect",
        attr: {
          x: "5.33331",
          width: "13.3333",
          height: "12.6667",
          rx: "3",
          fill: "#414141"
        }
      },
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9 4.25004C9 3.74378 9.41041 3.33337 9.91667 3.33337H14.0833C14.5896 3.33337 15 3.74378 15 4.25004V8.41671C15 8.92297 14.5896 9.33337 14.0833 9.33337H9.91667C9.41041 9.33337 9 8.92297 9 8.41671V4.25004ZM9.91667 3.83337C9.68655 3.83337 9.5 4.01992 9.5 4.25004V8.41671C9.5 8.64683 9.68655 8.83337 9.91667 8.83337H14.0833C14.3135 8.83337 14.5 8.64683 14.5 8.41671V4.25004C14.5 4.01992 14.3135 3.83337 14.0833 3.83337H9.91667ZM9.89998 7.83331L10.8 6.33331L11.7 7.23331L12.9 5.43331L14.1 7.83331H9.89998ZM11.7 4.98341C11.7 5.23193 11.4985 5.43341 11.25 5.43341C11.0015 5.43341 10.8 5.23193 10.8 4.98341C10.8 4.73488 11.0015 4.53341 11.25 4.53341C11.4985 4.53341 11.7 4.73488 11.7 4.98341Z",
          fill: "#F3F3F3"
        }
      },
      {
        tag: "g",
        attr: { clipPath: "url(#clip1)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M20.5555 7.88892L22.1111 6.33336L20.5555 4.7778",
              stroke: "white",
              strokeWidth: "0.333333",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0" },
            child: [
              {
                tag: "rect",
                attr: {
                  width: "5.33333",
                  height: "5.33333",
                  fill: "white",
                  transform: "translate(0 3.66663)"
                }
              }
            ]
          },
          {
            tag: "clipPath",
            attr: { id: "clip1" },
            child: [
              {
                tag: "rect",
                attr: {
                  width: "5.33333",
                  height: "5.33333",
                  fill: "white",
                  transform: "translate(18.6667 3.66663)"
                }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};

export { SliderFilled };
